import { Header } from "../../components/Header";
import { HeroHome } from "./HeroHome";
import './Home.css';


import { ServicesComponent } from "./ServicesComponent";
import { Footer } from "../../components/Footer";
import { ProcessComponent } from "./ProcessComponent";
import { StatsComponent } from "./StatsComponent";
import LogisticsBanner from "./LogisticsBanner";
import Building from "./Building";
import Quote from "./Quote";
import Projects from './Projects';

export const Home = () => {
    return (
        <>
       
    <HeroHome />
    <ServicesComponent />
    <Quote/>
  
<Projects/>
    {/* <ProcessComponent />
    <StatsComponent />
    <LogisticsBanner/> */}
    {/* <div className="container">
          <div className="website-under-construction">Website Under Construction</div>
          <div className="website-description">
            Labh Industries is a leader in Engineering, Procurement, and Construction (EPC), delivering turnkey solutions for factories, warehouses, PEB structures, roads, flooring and corporate offices. With a commitment to innovation and precision, we design and construct high-quality industrial infrastructure, ensuring durability and efficiency. Our expertise spans from concept to completion, providing seamless project execution with state-of-the-art engineering and sustainable practices. At Labh Industries, we transform visions into reality, building the future with excellence and reliability.
          </div>
        </div>
        <div className="frame-903"></div>
        <div className="divider">
          <div className="under-construction">● Website Under Construction ●</div>
        </div> */}
    <Footer />
    {/* <section className="flex items-center justify-center">
 

    <div class="our-services">Our Services</div>
    <div class="fast-and-professional-logistic-services">
      <span>
        <span class="fast-and-professional-logistic-services-span">
          Fast and professional
        </span>
        <span class="fast-and-professional-logistic-services-span2"></span>
        <span class="fast-and-professional-logistic-services-span3">
          Logistic services
        </span>
      </span>
    </div>
    <div class="frame-325">
      <img class="rectangle-112" src={image1120} />
      <div
        class="comprehensive-reliable-cost-effective-ocean-freight-solutions-for-seamless-global-trade-shipping"
      >
        Comprehensive, Reliable &amp; Cost-Effective Ocean Freight Solutions for
        Seamless Global Trade &amp; Shipping.
      </div>
      <div class="ocean-freight">Ocean Freight</div>
      <div class="frame-323">
        <img class="image-14" src={image140} />
      </div>
      <div class="component-6">
        <div class="learn-more">Learn More</div>
        <div class="arrow-arrow-right">
            <div class="circle"></div>
          <img class="arrow-right" src={arrowRight0} />
        </div>
      </div>
    </div>
    <div class="frame-326">
      <img class="rectangle-1122" src={image1121} />
      <div
        class="comprehensive-reliable-cost-effective-ocean-freight-solutions-for-seamless-global-trade-shipping"
      >
        Comprehensive, Reliable &amp; Cost-Effective Ocean Freight Solutions for
        Seamless Global Trade &amp; Shipping.
      </div>
      <div class="air-freight">Air Freight</div>
      <div class="frame-323">
        <img
          class="freepicdownloader-com-airplane-hong-kong-international-airport-large"
          src={freepicdownloaderComAirplaneHongKongInternationalAirportLarge}
        />
      </div>
      <div class="component-6">
        <div class="learn-more">Learn More</div>
        <div class="arrow-arrow-right">
          <div class="circle"></div>
          <img class="arrow-right2" src={arrowRight1} />
        </div>
      </div>
    </div>
    <div class="frame-327">
      <img class="rectangle-1123" src={image1122} />
      <div
        class="comprehensive-reliable-cost-effective-ocean-freight-solutions-for-seamless-global-trade-shipping"
      >
        Comprehensive, Reliable &amp; Cost-Effective Ocean Freight Solutions for
        Seamless Global Trade &amp; Shipping.
      </div>
      <div class="road-freight">Road Freight</div>
      <div class="frame-323">
        <img class="image-18" src={image180} />
      </div>
      <div class="component-6">
        <div class="learn-more">Learn More</div>
        <div class="arrow-arrow-right">
          <div class="circle"></div>
          <img class="arrow-right3" src={arrowRight2} />
        </div>
      </div>
    </div>
    <div class="component-3">
      <div class="view-all">View all</div>
      <div class="arrow-arrow-right2">
        <div class="circle2"></div>
        <img class="arrow-right4" src={arrowRight3} />
      </div>
    </div>
    </section> */}
    
    </>
    )
 }  

export default Home;
